export const rules = {
  email: [
    {
      type: "email",
      message: "Please enter a valid email",
    },
    {
      required: true,
      message: "Please enter your email",
    },
  ],
  password: [
    {
      required: true,
      message: "Please enter your password",
    },
  ],
  current_password: [
    {
      required: true,
      message: "Please enter your current password",
    },
  ],
  radio:[
    {
      required: true,
      message: "Please choose one option",
    },
  ],
  course:[
    {
      required: true,
      message: "Please select a course",
    },
  ],
  certificate_status:[
    {
      required: true,
      message: "Please select certificate status",
    },
  ],
  new_password: [
    // {
    //   required: true,
    //   message: "Please enter your new password",
    // },
    // ({ getFieldValue }) => ({
    //   validator(_, value) {
    //     if (!value || getFieldValue("current_password") !== value) {
    //       return Promise.resolve();
    //     }
    //     return Promise.reject(
    //       new Error("New password cannot be same as current password!")
    //     );
    //   },
    // }),
    {
      validator: (_, value) => {
        const re = /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,}$/;
        if (!value) {
          return Promise.reject("Please enter your new password");
        } else if (!re.test(value)) {
          return Promise.reject("Not a valid new password");
        } else {
          return Promise.resolve();
        }
      }
    }
  ],
  confirm_password: [
    {
      required: true,
      message: "Please enter your confirm password",
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("new_password") === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error("New password and confirm password must be same")
        );
      },
    }),
  ],
  categoryName: [
    {
      validator: (_, value) => {
        const re = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (!value) {
          return Promise.reject("Please enter skill name");
        } else if (re.test(value)) {
          return Promise.reject(
            "Please not enter special characters"
          );
        } else if (value.length > 50) {
          return Promise.reject("Skill can only be 50 chars long");
        } else {
          return Promise.resolve();
        }
      },
    },
  ],
  homepage_skill_name: [
    {
      validator: (_, value) => {
        const re = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (!value) {
          return Promise.reject("Please enter homepage skill name");
        } else if (re.test(value)) {
          return Promise.reject(
            "Please not enter special characters"
          );
        } else if (value.length > 50) {
          return Promise.reject("Skill can only be 50 chars long");
        } else {
          return Promise.resolve();
        }
      },
    }
  ],
  degreeName: [
    {
      validator: (_, value) => {
        const re = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (!value) {
          return Promise.reject("Please enter degree name");
        } else {
          return Promise.resolve();
        }
      },
    },
  ],
  name: [
    {
      required: true,
      message: "Please enter a course name",
    },
  ],
  first_name: [
    {
      required: true,
      message: "Please enter a First name",
    },
  ],
  last_name: [
    {
      required: true,
      message: "Please enter a Last name",
    },
  ],
  bio_raw: [
    {
      required: true,
      message: "Please enter a course description",
    },
  ],
  post_message: [
    {
      required: true,
      message: "Please enter a Post Message",
    },
  ],
};
